export interface RegisterModalParams {
  step?: NamesSteps;
  isAdditionalData?: boolean;
}

export enum NamesSteps {
  PRIMARY_INFORMATION = 'step1',
  PERSONAL_INFORMATION = 'step2',
  ADDRESS_INFORMATION = 'step3',
}

export const totalSteps = 3;

export const fieldsMap: { [step: string]: string[] } = {
  [NamesSteps.PERSONAL_INFORMATION]: [
    'firstName',
    'lastName',
    'dateOfBirth',
    'mobilePhone',
    // synthetic inputs
    'mobilePhone.number',
  ],
  [NamesSteps.ADDRESS_INFORMATION]: [
    'country',
    'state',
    'city',
    'address',
    'postalCode',
  ],
};

export const replaceErrorFieldMap = {
  mobilePhone: 'mobilePhone.number',
};

export const LOCAL_STORAGE_REG_FORM_KEY = 'registration-form';
export const LOCAL_STORAGE_USER_INFO_FORM_KEY = 'user-information-form';
export const AUTO_REGISTRATION_QUERY_NAME = 'auto-registration';
